module.exports = "https://www.gc-qa.gnp.com.mx/190453fbece573675b8c1d1f6cab66eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_user.png
// module id = 981
// module chunks = 0